import { prop } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'js/store/hooks';
import { storageService } from 'js/services/storage.service';

import { showAgeVerificationPopupAction } from './actions';
import * as constants from './constants';

export const useAgeVerificationPopup = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const enableAgeVerification = useAppSelector(prop('enableAgeVerification'));

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const isHideAVP = params.get('hideAVP') === '1';

        if (!enableAgeVerification || isHideAVP || storageService.local.getItem(constants.AGE_VERIFIED_FLAG)) {
            return;
        }

        dispatch(showAgeVerificationPopupAction({
            onClose: () => storageService.local.setItem(constants.AGE_VERIFIED_FLAG, 1)
        }));
    }, [
        dispatch,
        enableAgeVerification,
        location
    ]);
};
